{
  "error500": {
    "title": "500 Greška na serveru",
    "subtitle": "Nešto je pošlo po zlu sa naše strane",
    "description": "Izvinjavamo se na neprijatnosti. Došlo je do interne greške na serveru i nismo mogli da obradimo vaš zahtev. Naš tim je obavešten.",
    "tryAgain": "Pokušaj ponovo",
    "goHome": "Idi na početnu",
    "errorCode": "Kod greške"
  },
  "sidebar": {
    "title": "Bočna Traka",
    "mobileDescription": "Prikazuje mobilnu bočnu traku.",
    "toggle": "Preklopi Bočnu Traku"
  },
  "nav": {
    "dashboard": "Početna",
    "counters": "Brojači",
    "users": "Korisnici",
    "activityHistory": "Aktivnost",
    "profile": "Profil",
    "settings": "Podešavanja",
    "collapse": "Skupi",
    "logout": "Odjava"
  },
  "theme": {
    "light": "Svetlo",
    "dark": "Tamno",
    "system": "Sistem"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Српски"
  },
  "common": {
    "user": "Korisnik",
    "cancel": "Otkaži",
    "save": "Sačuvaj",
    "dismiss": "Zatvori"
  },
  "login": {
    "title": "Dobrodošli nazad",
    "description": "Unesite vaše podatke za prijavu na vaš nalog",
    "identifier": {
      "username": "Korisničko ime",
      "email": "Email",
      "both": "Korisničko ime ili email",
      "placeholder": "Unesite {{field}}"
    },
    "password": {
      "label": "Lozinka",
      "placeholder": "Unesite vašu lozinku"
    },
    "button": "Prijavi se",
    "button.loading": "Prijavljivanje...",
    "error": {
      "identifierRequired": "{{field}} je obavezno polje",
      "passwordLength": "Lozinka mora imati najmanje 6 karaktera",
      "failed": "Prijava nije uspela",
      "unknown": "Došlo je do neočekivane greške"
    },
    "forgotPassword": "Zaboravili ste lozinku?",
    "noAccount": "Nemate nalog?",
    "signUp": "Registrujte se"
  },
  "invitation": {
    "title": "Završite Vašu Registraciju",
    "description": "Postavite vašu lozinku da aktivirate vaš nalog",
    "username": "Korisničko ime",
    "password": "Lozinka",
    "passwordPlaceholder": "Unesite vašu lozinku",
    "confirmPassword": "Potvrdite Lozinku",
    "confirmPasswordPlaceholder": "Potvrdite vašu lozinku",
    "button": "Postavi Lozinku i Aktiviraj",
    "button.loading": "Postavljanje...",
    "invalidTitle": "Nevažeća Pozivnica",
    "goToLogin": "Idi na Prijavu",
    "resetPassword": {
      "title": "Resetuj Vašu Lozinku",
      "description": "Unesite novu lozinku za vaš nalog",
      "button": "Resetuj Lozinku",
      "button.loading": "Resetovanje..."
    },
    "error": {
      "noToken": "Token za pozivnicu nije prosleđen",
      "invalidToken": "Nevažeći ili istekao token za pozivnicu",
      "passwordLength": "Lozinka mora imati najmanje 8 karaktera",
      "passwordMismatch": "Lozinke se ne poklapaju",
      "failed": "Neuspešno postavljanje lozinke. Molimo pokušajte ponovo."
    }
  },
  "profile": {
    "title": "Moj Nalog",
    "subtitle": "Upravljajte profilom i bezbednosnim podešavanjima",
    "edit": "Izmeni",
    "verified": "Verifikovan",
    "updateSuccess": "Profil uspešno ažuriran",
    "updateError": "Greška pri ažuriranju profila",
    "info": {
      "title": "Informacije o Profilu",
      "description": "Detalji vašeg naloga"
    },
    "field": {
      "name": "Puno Ime",
      "username": "Korisničko Ime",
      "email": "Email",
      "memberSince": "Član Od"
    },
    "editModal": {
      "title": "Izmeni Profil",
      "description": "Ažurirajte informacije vašeg profila"
    },
    "security": {
      "title": "Promeni Lozinku",
      "description": "Ažurirajte lozinku da biste zaštitili vaš nalog",
      "currentPassword": "Trenutna Lozinka",
      "newPassword": "Nova Lozinka",
      "confirmPassword": "Potvrdite Novu Lozinku",
      "passwordMismatch": "Lozinke se ne poklapaju",
      "passwordInvalid": "Lozinka ne ispunjava zahteve",
      "changeSuccess": "Lozinka uspešno promenjena. Ostale sesije su zatvorene.",
      "changeError": "Greška pri promeni lozinke",
      "changeButton": "Promeni Lozinku"
    },
    "sessions": {
      "currentSession": "Trenutna Sesija",
      "current": "Trenutna",
      "device": "Uređaj",
      "ip": "IP Adresa",
      "lastActive": "Poslednja Aktivnost",
      "now": "Sada",
      "unknown": "Nepoznato",
      "otherSessions": "Ostale Sesije",
      "otherDescription": "Sesije aktivne na drugim uređajima",
      "revokeAll": "Opozovi Sve",
      "revoke": "Opozovi",
      "revokeSuccess": "Sesija uspešno opozvana",
      "revokeError": "Greška pri opozivanju sesije",
      "revokeAllSuccess": "Sve ostale sesije su zatvorene",
      "revokeAllError": "Greška pri opozivanju sesija",
      "noOtherSessions": "Nema drugih aktivnih sesija",
      "lastActiveAt": "Poslednja aktivnost {{time}}",
      "neverActive": "Nikada aktivna",
      "confirmRevokeAll": {
        "title": "Opozovi Sve Sesije",
        "description": "Ovo će zatvoriti sve ostale sesije. Ostaćete prijavljeni na ovom uređaju."
      },
      "time": {
        "daysAgo": "pre {{count}} d",
        "hoursAgo": "pre {{count}} h",
        "justNow": "upravo sada",
        "minutesAgo": "pre {{count}} min"
      },
      "unknownBrowser": "Nepoznat pregledač",
      "unknownDevice": "Nepoznat uređaj"
    }
  },
  "settings": {
    "title": "Podešavanja",
    "subtitle": "Upravljajte preferencama vaše aplikacije",
    "theme": "Tema",
    "themeDescription": "Izaberite vašu željenu temu",
    "language": "Jezik",
    "languageDescription": "Izaberite vaš željeni jezik"
  },
  "users": {
    "title": "Korisnici",
    "button": {
      "add": "Dodaj Korisnika",
      "resetPassword": "Resetuj Lozinku",
      "resendInvitation": "Pošalji Pozivnicu Ponovo",
      "deactivate": "Deaktiviraj",
      "activate": "Aktiviraj",
      "demoteFromAdmin": "Ukloni ulogu administratora",
      "promoteToAdmin": "Unapredi u administratora",
      "delete": "Obriši"
    },
    "table": {
      "username": "Korisničko ime",
      "email": "Email",
      "name": "Ime",
      "role": "Uloga",
      "status": "Status",
      "lastLogin": "Poslednja Prijava",
      "created": "Kreiran",
      "actions": "Akcije",
      "noResults": "Nema pronađenih korisnika",
      "roles": "Uloge"
    },
    "status": {
      "active": "Aktivan",
      "inactive": "Neaktivan"
    },
    "date": {
      "never": "Nikad"
    },
    "actions": {
      "label": "Akcije",
      "copyId": "Kopiraj ID korisnika",
      "editUser": "Izmeni korisnika",
      "openMenu": "Otvori meni",
      "viewDetails": "Prikaži detalje"
    },
    "filter": {
      "allRoles": "Sve Uloge",
      "allStatus": "Svi Statusi"
    },
    "search": {
      "placeholder": "Pretraži po korisničkom imenu..."
    },
    "error": {
      "create": "Neuspešno kreiranje korisnika",
      "delete": "Neuspešno brisanje korisnika",
      "resetPassword": "Neuspešno resetovanje lozinke",
      "resendInvitation": "Neuspešno slanje pozivnice",
      "activate": "Neuspešno aktiviranje korisnika",
      "demote": "Uklanjanje uloge korisniku nije uspelo",
      "promote": "Unapređenje korisnika nije uspelo",
      "deactivate": "Neuspešno deaktiviranje korisnika"
    },
    "role": {
      "USER": "Korisnik",
      "ADMIN": "Administrator",
      "SUPERADMIN": "Super Administrator"
    },
    "modal": {
      "add": {
        "title": "Dodaj Novog Korisnika",
        "description": "Kreirajte novi korisnički nalog. Biće generisan link za pozivnicu.",
        "name": "Ime",
        "namePlaceholder": "Unesite puno ime...",
        "email": "Email",
        "emailPlaceholder": "Unesite email...",
        "emailOptional": "Email (opciono)",
        "identifierHint": "Unesite korisničko ime, email ili oboje — korisnik se prijavljuje onim što postavite.",
        "username": "Korisničko ime",
        "usernamePlaceholder": "Unesite korisničko ime...",
        "role": "Uloga",
        "password": "Lozinka (opciono)",
        "passwordPlaceholder": "Ostavite prazno za slanje linka za pozivnicu",
        "passwordHint": "Ako se ostavi prazno, biće generisan link za pozivnicu kako bi korisnik postavio svoju lozinku.",
        "button": "Kreiraj Korisnika",
        "rolePlaceholder": "Izaberite ulogu"
      },
      "invitation": {
        "copied": "Link je kopiran",
        "copyFailed": "Kopiranje nije uspjelo. Kopirajte link ručno.",
        "title": "Link za Pozivnicu",
        "message": "Podelite ovaj link sa korisnikom da završi svoju registraciju.",
        "emailSent": "Pozivnica je poslata na {{email}}.",
        "emailFailed": "Pozivnica nije mogla biti poslata na {{email}}. Pošaljite link ispod ručno.",
        "button": {
          "copy": "Kopiraj Link",
          "done": "Gotovo"
        }
      },
      "deactivate": {
        "title": "Deaktiviraj Korisnika",
        "message": "Da li ste sigurni da želite da deaktivirate {{username}}?",
        "button": "Deaktiviraj"
      },
      "selfReset": {
        "title": "Resetuj Vašu Lozinku",
        "message": "Upravo ćete resetovati svoju lozinku. Bićete odjavljeni i moraćete koristiti link za pozivnicu da se ponovo prijavite.",
        "button": "Resetuj Lozinku"
      },
      "button": {
        "cancel": "Otkaži"
      },
      "delete": {
        "title": "Obriši Korisnika",
        "message": "Ovo trajno briše {{username}} i ne može se poništiti. Nalog se odjavljuje svuda i više nikada ne može da se prijavi, a njegovo korisničko ime i email postaju slobodni za nekog drugog. Da samo uklonite pristup, deaktivirajte ga.",
        "confirm": "Upišite {{username}} da potvrdite",
        "button": "Obriši Korisnika"
      }
    },
    "card": {
      "total": "ukupno"
    },
    "pagination": {
      "of": "od",
      "page": "Strana",
      "rowsPerPage": "Redova po strani"
    }
  },
  "counters": {
    "title": "Brojači",
    "description": "Upravljajte vašim brojačima",
    "newCounter": "Novi Brojač",
    "empty": "Još nema brojača. Kreirajte jedan da počnete!",
    "lastUpdated": "Poslednje ažurirano:",
    "modal": {
      "title": "Kreiraj Novi Brojač",
      "description": "Unesite ime za vaš novi brojač.",
      "nameLabel": "Ime Brojača",
      "namePlaceholder": "Unesite ime brojača...",
      "cancel": "Otkaži",
      "create": "Kreiraj"
    },
    "clearAll": "Obriši sve",
    "clearAllModal": {
      "cancel": "Otkaži",
      "confirm": "Obriši sve",
      "description": "Da li ste sigurni da želite da obrišete svih {{count}} brojača? Ova radnja se ne može poništiti.",
      "title": "Obriši sve brojače"
    },
    "error": {
      "create": "Kreiranje brojača nije uspelo",
      "decrement": "Umanjenje brojača nije uspelo",
      "delete": "Brisanje brojača nije uspelo",
      "deleteAll": "Brisanje svih brojača nije uspelo",
      "increment": "Uvećanje brojača nije uspelo",
      "reset": "Resetovanje brojača nije uspelo"
    },
    "loadError": "Brojači nisu mogli da se učitaju.",
    "noResults": "Nijedan brojač ne odgovara vašoj pretrazi.",
    "search": "Pretraži brojače...",
    "toast": {
      "incremented": "Brojač je uvećan"
    },
    "total": "ukupno"
  },
  "activity": {
    "table": {
      "timestamp": "Vreme",
      "action": "Akcija",
      "entityType": "Tip Entiteta",
      "user": "Korisnik",
      "ip": "IP Adresa",
      "status": "Status",
      "noResults": "Nema pronađenih zapisa aktivnosti"
    },
    "status": {
      "success": "Uspešno",
      "failed": "Neuspešno"
    },
    "filter": {
      "clear": "Obriši",
      "allActions": "Sve Akcije",
      "allEntities": "Svi Tipovi Entiteta",
      "allStatus": "Svi Statusi"
    },
    "entityType": {
      "session": "Sesija",
      "user": "Korisnik",
      "counter": "Brojač"
    },
    "action": {
      "LOGIN": "Prijava",
      "LOGIN_FAILED": "Neuspešna Prijava",
      "LOGOUT": "Odjava",
      "LOGOUT_ALL": "Odjava Svih",
      "TOKEN_REFRESH": "Obnova Tokena",
      "CREATE": "Kreiranje",
      "UPDATE": "Ažuriranje",
      "DELETE": "Brisanje",
      "PASSWORD_SET": "Postavljanje Lozinke",
      "PASSWORD_CHANGE": "Promena Lozinke",
      "PASSWORD_RESET": "Resetovanje Lozinke",
      "REGISTER": "Registracija",
      "EMAIL_VERIFY": "Verifikacija Emaila",
      "RESEND_VERIFICATION": "Ponovno Slanje Verifikacije"
    },
    "search": {
      "placeholder": "Pretraži po korisničkom imenu, IP, entitetu..."
    },
    "button": {
      "details": "Detalji"
    },
    "modal": {
      "title": "Detalji Aktivnosti"
    },
    "details": {
      "error": "Greška",
      "previousState": "Prethodno Stanje",
      "newState": "Novo Stanje",
      "metadata": "Metapodaci",
      "userAgent": "User Agent"
    },
    "pagination": {
      "of": "od",
      "page": "Strana",
      "rowsPerPage": "Redova po strani"
    }
  },
  "activityHistory": {
    "title": "Istorija Aktivnosti",
    "description": "Pregledajte sistemske revizijske logove i aktivnost korisnika",
    "card": {
      "total": "unosa"
    }
  },
  "toast": {
    "sessionExpired": "Sesija je istekla. Molimo prijavite se ponovo.",
    "deviceMismatch": "Ova sesija pripada drugom uređaju. Molimo prijavite se ponovo.",
    "rateLimited": "Previše zahteva. Molimo pokušajte ponovo kasnije.",
    "reconnecting": "Ponovno povezivanje…",
    "unreachable": "Nismo mogli da pristupimo serveru — možda se ponovo pokreće. Ništa nije sačuvano; pokušajte ponovo za trenutak."
  },
  "backend": {
    "accountLocked": "Previše neuspešnih pokušaja prijave. Pokušajte ponovo za {{seconds}} sekundi",
    "accountLockedTitle": "Nalog je privremeno zaključan",
    "badRequest": "Zahtev nije ispravan",
    "cannotAssignCustomerRole": "Uloga korisnika-kupca ne može da se dodeli nalozima kojima upravljaju administratori",
    "cannotDeactivateOwnAccount": "Ne možete deaktivirati sopstveni nalog",
    "cannotDeleteOwnAccount": "Ne možete obrisati sopstveni nalog",
    "cannotDeleteSuperAdmin": "Super administratori ne mogu da se obrišu",
    "cannotModifyOwnRoles": "Ne možete menjati sopstvene uloge",
    "cannotModifyOwnSuperAdmin": "Ne možete menjati sopstveni status super administratora",
    "cannotResendSuperAdminInvitation": "Pozivnice ne mogu ponovo da se šalju super administratorima",
    "cannotResetSuperAdminPassword": "Lozinka super administratora ne može ovde da se resetuje",
    "cannotUpdateSuperAdmin": "Super administratori ne mogu da se menjaju",
    "conflict": "Ovo već postoji",
    "counterNotFound": "Brojač nije pronađen",
    "currentPasswordIncorrect": "Trenutna lozinka nije tačna",
    "emailAlreadyVerified": "Ovaj email je već potvrđen. Možete se prijaviti.",
    "emailExists": "Ovaj email je već registrovan",
    "emailNotVerified": "Potvrdite vaš email pre prijave",
    "emailRequired": "Email je obavezan",
    "fetchActivityFailed": "Aktivnost nije mogla da se učita",
    "fetchProfileFailed": "Profil nije mogao da se učita",
    "fetchSessionsFailed": "Sesije nisu mogle da se učitaju",
    "fetchUsersFailed": "Korisnici nisu mogli da se učitaju",
    "forbidden": "Nemate dozvolu za to",
    "identifierInUse": "To korisničko ime ili email je već u upotrebi",
    "identifierRequired": "Korisničko ime ili email je obavezan",
    "invalidCredentials": "Pogrešno korisničko ime ili lozinka",
    "invalidEmail": "Neispravan format email adrese",
    "invalidInvitationToken": "Nevažeći ili istekao link pozivnice",
    "invalidResetToken": "Ovaj link za resetovanje lozinke nije važeći ili je istekao",
    "invalidVerificationToken": "Ovaj link za potvrdu nije važeći ili je istekao",
    "logoutAllFailed": "Odjava ostalih sesija nije uspela",
    "logoutFailed": "Odjava nije uspela",
    "newPasswordSameAsCurrent": "Nova lozinka mora da se razlikuje od trenutne",
    "noPlatformAccess": "Vaš nalog nema pristup ovoj aplikaciji",
    "notFound": "Nije pronađeno",
    "onlySuperAdminsCreateSuperAdmins": "Samo super administratori mogu da kreiraju super administratore",
    "onlySuperAdminsManageSuperAdmins": "Samo super administratori mogu da upravljaju statusom super administratora",
    "passwordAlreadySet": "Ovaj korisnik je već postavio lozinku. Umesto toga koristite resetovanje lozinke.",
    "passwordComplexity": "Lozinka ne ispunjava zahteve",
    "passwordMinLength": "Lozinka mora imati najmanje {{count}} karaktera",
    "passwordNotSet": "Ovaj nalog nema postavljenu lozinku",
    "passwordSetupRequired": "Morate postaviti lozinku pre prijave",
    "profileNotFound": "Profil nije pronađen",
    "registrationFailed": "Registracija nije uspela",
    "registrationUnavailable": "Registracija nije dostupna",
    "resetPasswordFailed": "Resetovanje lozinke nije uspelo",
    "revokeSessionFailed": "Opoziv sesije nije uspeo",
    "securityCheckFailed": "Bezbednosna provera nije uspela. Osvežite stranicu i pokušajte ponovo.",
    "serverError": "Došlo je do greške na našoj strani. Pokušajte ponovo.",
    "sessionNotFound": "Sesija nije pronađena",
    "tooManyLoginAttempts": "Previše pokušaja prijave. Pokušajte ponovo za {{seconds}} sekundi",
    "updateUserFailed": "Ažuriranje korisnika nije uspelo",
    "userNotFound": "Korisnik nije pronađen",
    "usernameDerivedFromEmail": "Korisničko ime se izvodi iz emaila kada je prijava putem emaila",
    "usernameExists": "Korisničko ime već postoji",
    "usernameRequired": "Korisničko ime je obavezno",
    "verificationFailed": "Potvrda nije uspela",
    "verificationUnavailable": "Potvrda emaila nije dostupna",
    "verifyInvitationFailed": "Pozivnica nije mogla da se proveri",
    "accountDeactivated": "Nalog je deaktiviran",
    "accountLockedFor": "Nalog je zaključan na {{seconds}} sekundi",
    "invalidPassword": "Pogrešna lozinka",
    "invalidPasswordLocked": "Pogrešna lozinka – nalog je zaključan na {{seconds}} sekundi",
    "passwordPolicyDefault": "Lozinka mora da sadrži veliko slovo, malo slovo, broj i specijalni znak",
    "platformAccessDenied": "Pristup odbijen za ovu platformu ({{platform}})",
    "sendVerificationFailed": "Email za potvrdu nije mogao da se pošalje"
  },
  "dataTable": {
    "clearFilters": "Očisti filtere",
    "columns": "Kolone",
    "noResults": "Nema rezultata.",
    "pagination": {
      "next": "Sledeća",
      "pageOf": "Strana {{page}} od {{pageCount}}",
      "perPage": "{{count}} / strana",
      "previous": "Prethodna",
      "showing": "Prikazano {{from}}–{{to}} od {{total}} rezultata"
    },
    "rowsSelected": "Izabrano {{selected}} od {{total}} redova.",
    "searchPlaceholder": "Pretraži...",
    "column": {
      "actions": "Radnje",
      "createdAt": "Kreirano",
      "isActive": "Status",
      "lastLoginAt": "Poslednja prijava",
      "name": "Ime",
      "roles": "Uloge",
      "username": "Korisničko ime"
    }
  },
  "forgotPassword": {
    "backToLogin": "Nazad na prijavu",
    "description": "Unesite vaš email i poslaćemo vam link za resetovanje.",
    "email": "Email",
    "emailPlaceholder": "Unesite vaš email",
    "sent": {
      "description": "Ako nalog sa ovim emailom postoji, dobićete link za resetovanje lozinke.",
      "title": "Proverite vaš email"
    },
    "submit": "Pošalji link za resetovanje",
    "title": "Zaboravljena lozinka"
  },
  "password": {
    "error": {
      "complexity": "Lozinka ne ispunjava zahteve",
      "minLength": "Lozinka mora imati najmanje {{count}} karaktera"
    },
    "requirement": {
      "complexity": "Ispunjava zahteve složenosti",
      "minLength": "Najmanje {{count}} karaktera"
    },
    "show": "Prikaži lozinku",
    "hide": "Sakrij lozinku"
  },
  "register": {
    "button": "Napravi nalog",
    "button.loading": "Kreiranje naloga...",
    "confirmPassword": {
      "label": "Potvrdite lozinku",
      "placeholder": "Potvrdite vašu lozinku"
    },
    "description": "Unesite svoje podatke da biste napravili nalog",
    "email": {
      "label": "Email",
      "placeholder": "Unesite vaš email"
    },
    "error": {
      "failed": "Registracija nije uspela. Pokušajte ponovo.",
      "invalidEmail": "Unesite ispravnu email adresu",
      "nameRequired": "Ime je obavezno",
      "passwordLength": "Lozinka mora imati najmanje 8 karaktera",
      "passwordMismatch": "Lozinke se ne poklapaju"
    },
    "hasAccount": "Već imate nalog?",
    "name": {
      "label": "Ime",
      "placeholder": "Unesite vaše ime"
    },
    "password": {
      "label": "Lozinka",
      "placeholder": "Unesite vašu lozinku"
    },
    "signIn": "Prijavite se",
    "success": "Registracija je uspela! Proverite vaš email da biste potvrdili nalog.",
    "title": "Napravite nalog"
  },
  "resetPassword": {
    "confirmPassword": "Potvrdite lozinku",
    "description": "Unesite vašu novu lozinku ispod.",
    "error": "Resetovanje lozinke nije uspelo",
    "goToLogin": "Idi na prijavu",
    "invalid": {
      "description": "Ovaj link za resetovanje lozinke je istekao ili nije važeći. Zatražite novi.",
      "title": "Nevažeći ili istekao link"
    },
    "newPassword": "Nova lozinka",
    "passwordInvalid": "Lozinka ne ispunjava zahteve",
    "passwordMismatch": "Lozinke se ne poklapaju",
    "requestNew": "Zatraži novi link",
    "submit": "Resetuj lozinku",
    "success": "Lozinka je uspešno resetovana",
    "success.description": "Uskoro ćete biti preusmereni na prijavu.",
    "success.title": "Lozinka je resetovana",
    "title": "Resetovanje lozinke"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "Ovaj link za potvrdu nije važeći ili je istekao.",
      "noToken": "Nije prosleđen token za potvrdu",
      "title": "Potvrda nije uspela"
    },
    "goToLogin": "Idi na prijavu",
    "needAccount": "Nemate nalog?",
    "resend": {
      "button": "Ponovo pošalji email za potvrdu",
      "cancel": "Otkaži",
      "email": {
        "label": "Email adresa",
        "placeholder": "Unesite vaš email"
      },
      "emailRequired": "Unesite vaš email",
      "sending": "Slanje...",
      "submit": "Pošalji",
      "success": "Ako je vaš email registrovan, dobićete email za potvrdu."
    },
    "signUp": "Registrujte se",
    "success": {
      "description": "Vaš email je uspešno potvrđen. Sada se možete prijaviti na svoj nalog.",
      "redirect": "Preusmeravanje na prijavu...",
      "title": "Email je potvrđen!"
    }
  },
  "unsavedChanges": {
    "title": "Izađi bez čuvanja?",
    "body": "Tvoje izmene će biti izgubljene.",
    "stay": "Ostani",
    "leave": "Izađi"
  },
  "richText": {
    "bold": "Podebljano",
    "italic": "Kurziv",
    "underline": "Podvučeno",
    "strike": "Precrtano",
    "heading": "Naslov",
    "paragraph": "Pasus",
    "bullets": "Lista sa tačkama",
    "numbers": "Numerisana lista",
    "quote": "Citat"
  }
}
